import { HOST, makePostApiRequest } from '@common/index';
import axios from 'axios';
import { showAlert } from '@common/helper';

export const saveEvidenceRequest = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId, requestSource, jobRowId, subJobRowId, mediaTypes, comments } = variables;
            const url = `${HOST}/evidence/save-request`;
            const data = {
                job_list_id: jobListId,
                evidence_request_source: requestSource,
                job_row_id: jobRowId,
                sub_job_row_id: subJobRowId,
                media_types: mediaTypes,
                comments
            };

            const response = await makePostApiRequest(url, data, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('POST Save evidence ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const undoEvidenceRequest = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId, jobRowId, subJobRowId } = variables;
            const url = `${HOST}/evidence/undo-request`;
            const data = {
                job_list_id: jobListId,
                job_row_id: jobRowId,
                sub_job_row_id: subJobRowId,
            };

            const response = await makePostApiRequest(url, data, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('POST UNDO evidence ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const viewEvidenceCall = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { evidenceId } = variables;
            const url = `${HOST}/evidence/view-evidence`;
            const data = {
                evidence_id: evidenceId
            };

            const response = await makePostApiRequest(url, data, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('POST VIEW evidence ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}